var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"text-center fw-100"},[_vm._v(" A Division of [Bank Name]"),_c('br'),_vm._v(" Privacy Policy | Terms of Use | [Company Name] © 2022 ")])])])])
}]

export { render, staticRenderFns }